<ng-container *ngFor="let item of projectExpenses$ | async">
  <app-expense-accordion [data]="item"></app-expense-accordion>
</ng-container>
<div *ngIf="isLoading" class="cssload-container">
  <div class="cssload-speeding-wheel"></div>
</div>
